export default __webpack_public_path__ + "static/media/home-active.35536d5f.svg";